import React, { Fragment } from "react";
import LeftLinks from "./left-links/LeftLinks";
import RightLinks from "./right-links/RightLinks";
import styles from "./TopBar.module.scss";
import Marquee from "react-easy-marquee";

const TopBar = () => {
  return (
    <Fragment>
      <nav className={styles.nav}>
        {/* <Marquee duration={15000} height="30px" reverse>
          <p className="mb-0 top-text-topbar" style={{ color: "#FFFFFF" }}>
          Website Under Development: Please avoid processing
          transactions. We&apos;ll be live soon!
          </p>
        </Marquee> */}
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className={styles.topbar}>
                <LeftLinks />
                <RightLinks />
              </div>
            </div>
          </div>
        </div>
      </nav>
    </Fragment>
  );
};

export default TopBar;
